import React, { useState, useRef, useEffect } from 'react';
import { CameraAccessPromptContainer } from './cameraaccess.styled';
import Button from '../../../../FlyfishComponents/Button';

function CameraAccess({ setOpenCamera, handleImageUpload }) {
	const [cameraStatus, setCameraStatus] = useState(null); // 'initial', 'granted', 'denied', 'error'
	const videoRef = useRef(null);
	const cameraRef = useRef(null);
	const cameraUploadRef = useRef(null);
	const [selectedImage, setSelectedImage] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		// Check camera permission status on component mount
		const checkCameraPermission = async () => {
			try {
				const permissionStatus = await navigator.permissions.query({
					//@ts-ignore
					name: 'camera',
				});
				setCameraStatus(permissionStatus.state);

				// Listen for permission changes
				permissionStatus.onchange = () => {
					setCameraStatus(permissionStatus.state);
				};
				console.log('permissionStatus.state', permissionStatus.state);
				if (permissionStatus.state === 'granted') {
					openCamera();
				} else if (permissionStatus.state === 'denied') {
					// Show a message prompting the user to re-enable the camera in settings
					alert(
						'Camera access has been blocked. Please enable it in your browser settings to use this feature.'
					);
				}
			} catch (error) {
				console.error('Error checking camera permissions:', error);
			}
		};

		checkCameraPermission();
	}, []);
	console.log('cameraSttaus', cameraStatus);

	const requestCameraAccess = async () => {
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ video: true });
			setCameraStatus('granted');
			if (videoRef.current) {
				videoRef.current.srcObject = stream;
				videoRef.current.play();
			}
		} catch (error) {
			console.error('Camera access denied or error:', error);
			setCameraStatus('denied');
		}
	};

	useEffect(() => {
		function handleClickOutside(event) {
			if (cameraRef.current && !cameraRef.current.contains(event.target)) {
				setOpenCamera(false);
			}
		}

		document.addEventListener('pointerdown', handleClickOutside);
		return () => {
			document.removeEventListener('pointerdown', handleClickOutside);
		};
	}, [cameraRef]);
	const openCamera = () => {
		// Check if ref exists before clicking
		if (cameraUploadRef.current) {
			cameraUploadRef.current.click();
		}
	};
	return (
		<div>
			{cameraStatus === 'granted' ? (
				<>
					<input
						ref={cameraUploadRef}
						id='uploadFromCamera'
						type='file'
						capture='environment'
						accept='.jpg,.jpeg,.png,.tiff,.webp,.bmp'
						style={{ display: 'none' }}
						onChange={handleImageUpload}
					/>
				</>
			) : (
				cameraStatus !== null && (
					<CameraAccessPromptContainer
						className={`ff-allow-access-prompt`}
						ref={cameraRef}
					>
						<div>
							<div className='three'>
								<div className='two'>
									<div className='one'>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='36'
											height='36'
											viewBox='0 0 36 36'
											fill='none'
										>
											<g id='center_focus_weak'>
												<mask
													id='mask0_420_11951'
													style={{ maskType: 'alpha' }}
													maskUnits='userSpaceOnUse'
													x='0'
													y='0'
													width='36'
													height='36'
												>
													<rect
														id='Bounding box'
														width='36'
														height='36'
														fill='#D9D9D9'
													/>
												</mask>
												<g mask='url(#mask0_420_11951)'>
													<path
														id='center_focus_weak_2'
														d='M7.5 31.5C6.675 31.5 5.96875 31.2063 5.38125 30.6188C4.79375 30.0312 4.5 29.325 4.5 28.5V24C4.5 23.575 4.64375 23.2188 4.93125 22.9313C5.21875 22.6438 5.575 22.5 6 22.5C6.425 22.5 6.78125 22.6438 7.06875 22.9313C7.35625 23.2188 7.5 23.575 7.5 24V28.5H12C12.425 28.5 12.7812 28.6438 13.0688 28.9313C13.3562 29.2188 13.5 29.575 13.5 30C13.5 30.425 13.3562 30.7812 13.0688 31.0687C12.7812 31.3562 12.425 31.5 12 31.5H7.5ZM28.5 31.5H24C23.575 31.5 23.2188 31.3562 22.9313 31.0687C22.6438 30.7812 22.5 30.425 22.5 30C22.5 29.575 22.6438 29.2188 22.9313 28.9313C23.2188 28.6438 23.575 28.5 24 28.5H28.5V24C28.5 23.575 28.6438 23.2188 28.9313 22.9313C29.2188 22.6438 29.575 22.5 30 22.5C30.425 22.5 30.7812 22.6438 31.0687 22.9313C31.3562 23.2188 31.5 23.575 31.5 24V28.5C31.5 29.325 31.2063 30.0312 30.6188 30.6188C30.0312 31.2063 29.325 31.5 28.5 31.5ZM4.5 12V7.5C4.5 6.675 4.79375 5.96875 5.38125 5.38125C5.96875 4.79375 6.675 4.5 7.5 4.5H12C12.425 4.5 12.7812 4.64375 13.0688 4.93125C13.3562 5.21875 13.5 5.575 13.5 6C13.5 6.425 13.3562 6.78125 13.0688 7.06875C12.7812 7.35625 12.425 7.5 12 7.5H7.5V12C7.5 12.425 7.35625 12.7812 7.06875 13.0688C6.78125 13.3562 6.425 13.5 6 13.5C5.575 13.5 5.21875 13.3562 4.93125 13.0688C4.64375 12.7812 4.5 12.425 4.5 12ZM28.5 12V7.5H24C23.575 7.5 23.2188 7.35625 22.9313 7.06875C22.6438 6.78125 22.5 6.425 22.5 6C22.5 5.575 22.6438 5.21875 22.9313 4.93125C23.2188 4.64375 23.575 4.5 24 4.5H28.5C29.325 4.5 30.0312 4.79375 30.6188 5.38125C31.2063 5.96875 31.5 6.675 31.5 7.5V12C31.5 12.425 31.3562 12.7812 31.0687 13.0688C30.7812 13.3562 30.425 13.5 30 13.5C29.575 13.5 29.2188 13.3562 28.9313 13.0688C28.6438 12.7812 28.5 12.425 28.5 12ZM18 24C16.35 24 14.9375 23.4125 13.7625 22.2375C12.5875 21.0625 12 19.65 12 18C12 16.35 12.5875 14.9375 13.7625 13.7625C14.9375 12.5875 16.35 12 18 12C19.65 12 21.0625 12.5875 22.2375 13.7625C23.4125 14.9375 24 16.35 24 18C24 19.65 23.4125 21.0625 22.2375 22.2375C21.0625 23.4125 19.65 24 18 24ZM18 21C18.825 21 19.5313 20.7063 20.1188 20.1188C20.7063 19.5313 21 18.825 21 18C21 17.175 20.7063 16.4688 20.1188 15.8813C19.5313 15.2937 18.825 15 18 15C17.175 15 16.4688 15.2937 15.8813 15.8813C15.2937 16.4688 15 17.175 15 18C15 18.825 15.2937 19.5313 15.8813 20.1188C16.4688 20.7063 17.175 21 18 21Z'
														fill='#501ACE'
													/>
												</g>
											</g>
										</svg>
									</div>
								</div>
							</div>
						</div>
						<p>
							To take a picture and upload, please allow Flyfish Fashion to
							access your camera.
						</p>
						<Button onClick={requestCameraAccess}>Allow access</Button>
					</CameraAccessPromptContainer>
				)
			)}
		</div>
	);
}

export default CameraAccess;
